import React from "react";
import "./Hero.css";
import heroImg from "../../assets/img/hero-bg.jpg";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="hero" className="hero section">
      <img src={heroImg} alt="Hero Background" />

      <div className="container" data-aos="fade-up">
        <h2>
          Learning Today, <br />
          Leading Your Career
        </h2>
        <p>
          We provide expert-led courses to help you build real-world skills.
        </p>

        <div className="d-flex mt-4">
          <button
            onClick={() => navigate("/courses")}
            className="btn-get-started"
          >
            {" "}
            Get Started{" "}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
